import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/home.vue'
import homepages from '../views/homepages/homepages.vue' //首页


Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    redirect: "/homepages",
    children: [{
        path: '/homepages',
        name: 'homepages',
        component: () => import('../views/homepages/homepages.vue') //首页
      },
      {
        path: '/productSolution',
        name: 'productSolution',
        component: () => import('../views/productCenter/productSolution.vue') //  书商一体化解决方案
      },
      {
        path: '/gisLighting',
        name: 'gisLighting',
        component: () => import('../views/productCenter/gisLighting.vue') // GIS智慧照明解决方案
      },
      {
        path: '/product',
        name: 'product',
        component: () => import('../views/productCenter/product.vue') //  阅点点 & 千悦福鲤
      },
      {
        path: '/shortMessage',
        name: 'shortMessage',
        component: () => import('../views/productCenter/shortMessage.vue') //短信服务平台
      },
      {
        path: '/serviceProvision',
        name: 'serviceProvision',
        component: () => import('../views/serviceProvision/serviceProvision.vue') //服务提供
      },
      {
        path: '/development',
        name: 'development',
        component: () => import('../views/development/development.vue') //开放平台
      },
      {
        path: '/customer',
        name: 'customer',
        component: () => import('../views/customer/customer.vue') //客户案例
      },
      {
        path: '/consultingService',
        name: 'consultingService',
        component: () => import('../views/consultingService/consultingService.vue') //咨询
      },
      {
        path: '/PressDocuments1',
        name: 'PressDocuments1',
        component: () => import('../views/PressDocuments/PressDocuments1.vue') //小小冒险队
      },
      {
        path: '/PressDocuments2',
        name: 'PressDocuments2',
        component: () => import('../views/PressDocuments/PressDocuments2.vue') //龙族发布会
      },
      {
        path: '/PressDocuments3',
        name: 'PressDocuments3',
        component: () => import('../views/PressDocuments/PressDocuments3.vue') //南京书展会
      },
      {
        path: '/PressDocuments4',
        name: 'PressDocuments4',
        component: () => import('../views/PressDocuments/PressDocuments4.vue') //屋檐的秘密
      },
      {
        path: '/PressDocuments5',
        name: 'PressDocuments5',
        component: () => import('../views/PressDocuments/PressDocuments5.vue') //围观吧少年
      },
      {
        path: '/PressDocuments6',
        name: 'PressDocuments6',
        component: () => import('../views/PressDocuments/PressDocuments6.vue') //南京市独角兽
      },
      {
        path: '/aboutusPages',
        name: 'aboutusPages',
        component: () => import('../views/aboutusPages/aboutusPages.vue') //关于我们
      },


    ]
  }

  // {
  //   path: '/demo',
  //   name: 'demo',

  //   component: () => import('../views/demo.vue'),

  // },

  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('../views/About.vue'),
  // },

]

const router = new VueRouter({
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js